import { Skeleton, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react'
import { useGetDiscountsOverview } from 'BrokerTsLib/src/hooks/useSupervizor'

import { TableSection } from '@/components/Section/TableSection'
import { formatDateTime } from '@/utils/formatDate'
import type { Product } from 'BrokerTsLib/src/enums'
import { getProductFullName } from 'BrokerTsLib/src/enums'

export const ProductDiscountsOverview = ({ product }: { product: Product }) => {
  const { data, isLoading } = useGetDiscountsOverview(product)

  return (
    <TableSection sectionTitle={getProductFullName(product)} wide>
      <Skeleton isLoaded={!isLoading} height={'100%'} minH={20}>
        <Table variant="striped" borderRadius={0}>
          <Thead>
            <Tr borderBottom="1px solid" borderBottomColor="gray.300">
              <Th fontWeight='bold'>Pojišťovna</Th>
              <Th fontWeight='bold' textAlign="right">Sleva</Th>
              <Th fontWeight='bold' textAlign="right">Min</Th>
              <Th fontWeight='bold' textAlign="right">Max</Th>
              <Th fontWeight='bold'>Kód</Th>
              <Th fontWeight='bold' textAlign="right">Platná do</Th>
            </Tr>
          </Thead>
          <Tbody>
            {data?.data.length === 0 ? (
              <Tr>
                <Td colSpan={6} textAlign="center" py={8}>
                  Žádné slevy
                </Td>
              </Tr>
            ) : (
              data?.data.map((group) =>
                group.items.map((discount, index) => (
                  <Tr
                    key={`${group.insurerId}_${discount.id}`}
                    borderBottom={
                      index === group.items.length - 1
                        ? '1px solid'
                        : 'none'
                    }
                    borderBottomColor="gray.200"
                  >
                    {index === 0 && (
                      <Th rowSpan={group.items.length} w={48}>
                        {group.insurerName}
                      </Th>
                    )}
                    <Td w={48} textAlign="right">
                      {discount.name}
                    </Td>
                    <Td w={20} textAlign="right">
                      {discount.minDiscount} {discount.unit}
                    </Td>
                    <Td w={20} textAlign="right">
                      {discount.maxDiscount} {discount.unit}
                    </Td>
                    <Td>{discount.code}</Td>
                    <Td textAlign="right">
                      {discount.validTo && formatDateTime(discount.validTo)}
                    </Td>
                  </Tr>
                )),
              )
            )}
          </Tbody>
        </Table>
      </Skeleton>
    </TableSection>
  )
}
